<script setup lang="ts">
import { watch } from 'vue';
import { RouterView, useRoute, useRouter } from 'vue-router';
import { storeToRefs } from 'pinia';
import { ElMessage } from 'element-plus';
import { useAuthStore } from '@/stores/auth';

const route = useRoute();
const router = useRouter();
const auth = useAuthStore();
const { isAuthenticated } = storeToRefs(auth);

watch(isAuthenticated, (is, was) => {
  if (!was || is) return;
  if (route.meta.guest) return;
  void router.replace({ name: 'login', query: { redirect: route.fullPath } });
  ElMessage.warning('登录已过期,请重新登录');
});
</script>

<template>
  <RouterView />
</template>

